import { CancelToken } from 'axios';
import { useCallback } from 'react';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { SegmentType } from '~src/interfaces/segment.interface';
import SelectorHandler from '~src/modules/okrs/manageObjectives/shared/SelectorHandler';
import { OwnersSection } from '~src/modules/okrs/manageObjectives/shared/shared.sc';
import PeopleChips
  from '~src/modules/surveys/components/schedules/scheduleItem/templates/sections/customInputs/PeopleChips';
import { fetchSearchSegments } from '~src/services/fetch/fetchSearchSegments.service';
import { validatorRequiredArr } from '~src/services/validators';

import { FieldType } from '~src/types';

const ObjectiveOwners = () => {
  const typedSearch = (value: string, cancelToken: CancelToken) =>
    fetchSearchSegments(value, cancelToken, [SegmentType.User]);

  const [t] = useTranslation();

  const renderChips = useCallback(({ input, meta: { touched, error } }: FieldType) => {
    const onChangePeople = (param: any) => input.onChange(param);
    return (
      <PeopleChips
        blank
        fetchSuggestions={typedSearch}
        chipsName="owners"
        selectedPeople={input.value ? input.value : []}
        onChangePeople={onChangePeople}
        errorTxt={touched ? error : null}
        t={t}
        placeHolderKey="x.okrs.objective.owners.placeholder"
      />
    );
  }, []);

  return (
    <OwnersSection>
      <SelectorHandler hoverTextKey="x.objective.add.icon.owners" iconName="iconPersonLock">
        {(_, select, blur) => (
          <Field
            name="owners"
            component={renderChips}
            onFocus={select}
            onBlur={blur}
            validate={validatorRequiredArr}
          />
        )}
      </SelectorHandler>
    </OwnersSection>
  );
};

export default ObjectiveOwners;
